import { createTheme, responsiveFontSizes } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1782FF",
    },
    secondary: {
      main: "#477BA1",
    },
    success: {
      main: "#5EFB44",
    },
  },
  typography: {
    fontFamily: ["Nunito Sans"].join(","),  

    h1: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 600,
    },
    h2: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 600,
    },
    h3: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 600,
    },
    h4: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 600,
    },
    h5: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 400,
    },
    h6: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 400,
    },
    caption: {
      fontFamily: ["Nunito Sans"].join(","),
      fontWeight: 400,
      color: "#808080",
    },
  },
});
export default responsiveFontSizes(theme);
